var _defs, _line, _path, _circle, _circle2, _line2, _line3, _line4, _path2, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.39,
    y1: 20.59,
    x2: 7.7,
    y2: 20.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.89,20.59H1.5V13.91l.69-4.13a1.92,1.92,0,0,1,1.88-1.6H15.39A1.91,1.91,0,0,1,17.2,9.49l1.48,4.42,3.82,1.91v4.77H18.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.3,
    cy: 20.59,
    r: 1.91
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.8,
    cy: 20.59,
    r: 1.91
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.68,
    y1: 13.91,
    x2: 4.36,
    y2: 13.91
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.95,
    y1: 10.09,
    x2: 12.95,
    y2: 13.91
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.23,
    y1: 10.09,
    x2: 7.23,
    y2: 13.91
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.32,1.5h8.59a2.86,2.86,0,0,1,2.86,2.86v1a0,0,0,0,1,0,0H2.45a0,0,0,0,1,0,0v-1A2.86,2.86,0,0,1,5.32,1.5Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.32,
    y1: 5.32,
    x2: 5.32,
    y2: 8.18
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.91,
    y1: 5.32,
    x2: 13.91,
    y2: 8.18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelType);
export default __webpack_public_path__ + "static/media/travel_type.c30eb742d631888d602eadc30b5728da.svg";
export { ForwardRef as ReactComponent };